#import "../fragments/queued-email-fragment.graphql"

mutation DelayQueuedEmail($payload: DelayQueuedEmailInput!) {
    delayQueuedEmail(input: $payload) {
        emailSequence {
            emailsQueued {
                ...QueuedEmail
            }
        }
    }
}
